// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__2Izd7"};